import React from "react";
import { ArrowRightOutlined, LockOutlined, MailOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";

interface EditorialLoginProps {
  loading: boolean;
  onSubmit: (values: { emailId: string; password: string }) => void;
  onForgotPassword: () => void;
}

const EditorialLogin: React.FC<EditorialLoginProps> = ({ loading, onSubmit, onForgotPassword }) => (
  <main className="editorial-login">
    <section className="editorial-login__visual" aria-label="iReed administration portal">
      <div className="editorial-login__shade" />
      <img className="editorial-login__brand-mark" src="/logo-dark.png" alt="iReed India" />
      <div className="editorial-login__story">
        <span className="editorial-login__eyebrow editorial-login__eyebrow--light">IREED INDIA · CONTROL PANEL</span>
        <h1>Manage learning,<br />people and progress.</h1>
        <p>Publish content, review trainers, and keep your entire learning ecosystem in sync—from one secure place.</p>
      </div>
      <span className="editorial-login__visual-footer">Secure administration workspace</span>
    </section>

    <section className="editorial-login__form-panel">
      <div className="editorial-login__form-wrap">
        <img className="editorial-login__mobile-logo" src="/logo-dark.png" alt="iReed India" />
        <span className="editorial-login__eyebrow">ADMIN CONTROL PANEL</span>
        <h2>Welcome back</h2>
        <p className="editorial-login__intro">Sign in with your dashboard account to continue.</p>

        <div className="editorial-login__tabs" aria-label="Sign-in method">
          <span className="active">Password</span>
        </div>

        <Form layout="vertical" requiredMark={false} onFinish={onSubmit} className="editorial-login__form">
          <Form.Item
            label="Email address"
            name="emailId"
            rules={[
              { required: true, message: "Please enter your email address" },
              { type: "email", message: "Please enter a valid email address" },
            ]}
          >
            <Input prefix={<MailOutlined />} placeholder="you@ireedindia.com" autoComplete="email" />
          </Form.Item>

          <Form.Item label="Password" name="password" rules={[{ required: true, message: "Please enter your password" }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Enter your password" autoComplete="current-password" />
          </Form.Item>

          <button type="button" className="editorial-login__forgot" onClick={onForgotPassword}>Forgot password?</button>

          <Button className="editorial-login__submit" htmlType="submit" loading={loading}>
            <span>Sign in</span><ArrowRightOutlined />
          </Button>
        </Form>

        <div className="editorial-login__secure"><span /> Protected by secure authentication</div>
      </div>
    </section>
  </main>
);

export default EditorialLogin;

